import * as styles from "./Hero.module.scss";

import { CustomVideoPlayer } from "components/design-system";
import HeroImage from "assets/media/images/customers/hero.png";
import { Play } from "assets/media/svgs";
import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Hero = () => {
  const [showVideoPlayer, setShowVideoPlayer] = React.useState(false);

  React.useEffect(() => {
    if (showVideoPlayer) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showVideoPlayer]);
  return (
    <section>
      <div className={styles.Hero_image}>
        <StaticImage
          src="../../../assets/media/images/customers/hero.png"
          alt="hero"
          as="span"
          loading="eager"
        />
        <div className={styles.Hero_image_action}>
          <Play
            onClick={() => {
              setShowVideoPlayer(true);
            }}
          />
        </div>
      </div>
      {showVideoPlayer && (
        <CustomVideoPlayer
          handleClose={() => {
            setShowVideoPlayer(false);
          }}
          source="vimeo"
          videoID="637218269?h=2a0f8b8a46"
          show={showVideoPlayer}
        />
      )}
    </section>
  );
};

export default Hero;
